var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalAttendanceVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32 23V21H27.3C26.5555 21 26.1832 21 25.882 20.9021C25.2731 20.7043 24.7957 20.2269 24.5979 19.618C24.5 19.3168 24.5 18.9445 24.5 18.2C24.5 17.0832 24.5 16.5248 24.3532 16.0729C24.0564 15.1596 23.3404 14.4436 22.4271 14.1468C21.9752 14 21.4168 14 20.3 14H12L12.0275 25C12.0822 26.0967 12.2454 26.7809 12.7322 27.2678C13.2191 27.7546 13.9033 27.9178 15 27.9724C15.0147 26.8806 15.9046 26 17 26C18.1046 26 19 26.8954 19 28H25C25 26.8954 25.8954 26 27 26C28.0954 26 28.9851 26.8806 28.9998 27.9725C30.0965 27.9178 30.7809 27.7546 31.2678 27.2678C32 26.5355 32 25.357 32 23Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.9724C13.9033 27.9178 13.2191 27.7546 12.7322 27.2678C12.2454 26.7809 12.0822 26.0967 12.0275 25M19 28H25M29 27.9724C30.0967 27.9178 30.7809 27.7546 31.2678 27.2678C32 26.5355 32 25.357 32 23V21H27.3C26.5555 21 26.1832 21 25.882 20.9021C25.2731 20.7043 24.7957 20.2269 24.5979 19.618C24.5 19.3168 24.5 18.9445 24.5 18.2C24.5 17.0832 24.5 16.5248 24.3532 16.0729C24.0564 15.1596 23.3404 14.4436 22.4271 14.1468C21.9752 14 21.4168 14 20.3 14H12",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30C28.1046 30 29 29.1046 29 28C29 26.8954 28.1046 26 27 26C25.8954 26 25 26.8954 25 28C25 29.1046 25.8954 30 27 30Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30C18.1046 30 19 29.1046 19 28C19 26.8954 18.1046 26 17 26C15.8954 26 15 26.8954 15 28C15 29.1046 15.8954 30 17 30Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H18",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21H16",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16H26.3212C27.7766 16 28.5042 16 29.0964 16.3537C29.6886 16.7074 30.0336 17.3481 30.7236 18.6295L32 21",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAttendanceVehicle);
export default __webpack_public_path__ + "static/media/total-attendance-vehicle.2e5d083352c3c13f86eefce47d7139c4.svg";
export { ForwardRef as ReactComponent };